var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-invalid-feedback',{attrs:{"state":_vm.state}},[(_vm.text !== '')?_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.$t('fieldobligatory'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }